import { API_BASE_URL_ADMIN } from 'shared/config';
import { API_URL } from 'shared/constants/api-url';
import { fetchBlob } from 'shared/utils/blob-fetch';

export type FetchTherapistsStatisticsParams = {
  startDate: string;
  endDate: string;
};

export type FetchTherapistsStatisticsResult = {
  blob?: Blob;
  filename: string;
  filesize: number;
  error?: string;
};

export async function fetchTherapistsStatisticsBlob(
  { startDate, endDate }: FetchTherapistsStatisticsParams,
  defaultFilename: string,
): Promise<FetchTherapistsStatisticsResult> {
  const url = new URL(
    `${API_BASE_URL_ADMIN}${API_URL.statisticsTherapistsExport}`,
  );
  url.search = new URLSearchParams({ startDate, endDate }).toString();

  const result = await fetchBlob(url.toString(), { defaultFilename });

  return {
    blob: result.blob,
    filename: result.filename,
    filesize: result.filesize,
    error: result.error,
  };
}
